import React from "react";
import "../Css/Accounts.css";
import {calculateByYear} from "../About/About";
import {Experience} from "../types";

interface ExperienceSectionProps {
    experiences?: Experience[],
}

export function ExperienceSection({experiences}:ExperienceSectionProps) {

    return (
        <section className="cv-section">
            <h2>Experience</h2>
            <div className="cv-experience">
                {experiences?.map((job) => {
                    const yearRange = calculateByYear(job);
                    return (
                        <div key={job.title} className="cv-job">
                            <a href={job.link ? job.link : '#'} target="_blank" rel="noopener noreferrer">{job.title}</a>
                            <div className="cv-job-years">
                                <span className="year-range">{yearRange}</span>
                            </div>
                            <h4>Responsibilities and Skills</h4>
                            <ul>
                                {job.responsibilities.map((item, i) => (
                                    <li key={i}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    );
                })}
            </div>
        </section>
    );
}
